import React from 'react';
import { i18n } from 'config/locales';
import ValidationElement from 'components/Form/ValidationElement';
import RadioGroup from 'components/Form/RadioGroup';
import Radio from 'components/Form/Radio';
import { ValidationElementProps } from 'components/Form/ValidationElement/ValidationElement';
import { ForeignTravelItemModel } from 'forms/sections/foreign/travel/types';
import { CommonOnError, CommonOnUpdate, CommonRequired } from 'types/props';

interface Props extends Partial<ForeignTravelItemModel['Days']>, ValidationElementProps {
  onUpdate?: CommonOnUpdate
  onError?: CommonOnError
  required?: CommonRequired
  className?: string
  attribute?: string
}

export default class TravelDaysPVQ extends ValidationElement<Props> {
  update = (values: ForeignTravelItemModel['Days']) => this.props.onUpdate?.({ value: values.value });

  render() {
    const selected = this.props.value;
    return (
      <RadioGroup
        className={`travel-days option-list option-list-vertical ${
          this.props.className || ''
        }`.trim()}
        onError={this.props.onError}
        required={this.props.required}
        selectedValue={selected}
        attribute={this.props.attribute}
      >
        <Radio
          name="less24"
          label={i18n.t('foreign.travel_pvq.label.one')}
          value="0-1"
          className="days-0-1"
          onUpdate={this.update}
          onError={this.props.onError}
        />
        <Radio
          name="days-1-7"
          label={i18n.t('foreign.travel_pvq.label.six')}
          value="1-7"
          className="days-1-7"
          onUpdate={this.update}
          onError={this.props.onError}
        />
        <Radio
          name="days-8-14"
          label={i18n.t('foreign.travel_pvq.label.eleven')}
          value="8-14"
          className="days-8-14"
          onUpdate={this.update}
          onError={this.props.onError}
        />
        <Radio
          name="days-15-30"
          label={i18n.t('foreign.travel_pvq.label.twentyone')}
          value="15-30"
          className="days-15-30"
          onUpdate={this.update}
          onError={this.props.onError}
        />
        <Radio
          name="more-than-30"
          label={i18n.t('foreign.travel_pvq.label.more')}
          value="Over 30"
          className="more-than-30"
          onUpdate={this.update}
          onError={this.props.onError}
        />
        <Radio
          name="many-short-trips"
          label={i18n.t('foreign.travel_pvq.label.many')}
          value="Many short trips"
          className="many-short-trips"
          onUpdate={this.update}
          onError={this.props.onError}
        />
      </RadioGroup>
    );
  }
}

TravelDaysPVQ.defaultProps = {
  value: '',
  onError: (value, arr) => arr,
};
